import {getAcceptedFileFormats} from '@/services/fileService';

export const validateReferenceFile = async (file) => {
    if (!file) {
        throw new Error('Reference file is required');
    }

    const fileName = file.name || '';
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    
    if (!fileExtension) {
        throw new Error('File must have an extension');
    }

    const response = await getAcceptedFileFormats(); 
    if(response.error){
        throw new Error(response.message);
    }
    const allowedExtensions = response.data.map(format => format.extension.toLowerCase());

    if (!allowedExtensions.includes(fileExtension)) {
        throw new Error(`Invalid file extension: ${fileExtension}. Allowed extensions: ${allowedExtensions.join(', ')}`);
    }
}